import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashNew from "./DashNew";
import { useGlobalContext } from "../../context/SocketContext";
import DashboardLayout from "../../layout/dashboardLayout";

function Dashboard() {
  const { globalState, setGlobalState } = useGlobalContext();

  const handleShowTicket = () => {
    setGlobalState({ dashboardSidebar: !globalState.dashboardSidebar });
  }
  useEffect(() => {
    console.log('globalState', globalState)
  }, [globalState])

  return (
    <DashboardLayout>
      <DashNew
        showSidebar={globalState}
        handleShowTicket={handleShowTicket} />
    </DashboardLayout>
  );
  // return (
  //   <div className={`dashboard_sec dashboard_sec_new ${!globalState ? "dash_transition" : ""}`}>
  //     <div className="container-fluid d-flex ps-0 pe-0">
  //       <div className={`left_side_sec ${globalState ? "sidebar_view" : "sidebar_hide"}`}>
  //         <Sidebar />
  //       </div>
  //       <div className="right_side_sec ">
  //         <div className="px-2 py-2 px-sm-4 py-sm-4">
  //           <Header />
  //         </div>
  //         <DashNew
  //           showSidebar={globalState}
  //           handleShowTicket={handleShowTicket} />
  //       </div>
  //     </div>
  //   </div >

  // );
}

export default Dashboard;
